var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecycoGenericInputComponent',{attrs:{"label":_vm.label,"icon":_vm.icon,"validate":_vm.validate,"value":_vm.value}},[_c('Datetime',_vm._b({attrs:{"input-class":"recyco-datetime-input","title":_vm.label,"phrases":{
      ok: _vm.$t('ok'),
      cancel: _vm.$t('cancel'),
    },"value":_vm.value},on:{"input":_vm.input}},'Datetime',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }